import cookie from 'react-cookie';

export const BRIEFS_FILTER_COOKIE_NAME = 'briefsFilters';

/**
 * Clear the persisted briefs filter cookie and navigate to a clean jobs URL.
 *
 * @param {object} history - react-router history
 * @param {object} [cookieApi]
 * @param {string} [path='/jobs'] - destination (e.g. role-only `/jobs/animators`)
 */
export default function clearJobsFilters(
  history,
  cookieApi = cookie,
  path = '/jobs'
) {
  cookieApi.remove(BRIEFS_FILTER_COOKIE_NAME, { path: '/' });
  history.push(path);
}
